'use client'

import { useCallback, useState } from 'react'

import { useNotificationsStore } from '@stores/notifications/notifications.store'

import { NotificationCard } from '../NotificationCard'

import styles from './NotificationToast.module.scss'

export function NotificationToast() {
  const notifications = useNotificationsStore((state) => state.notifications)
  const markAsRead = useNotificationsStore((state) => state.markAsRead)
  const dismissNotification = useNotificationsStore((state) => state.dismissNotification)
  const [initialNotificationIds] = useState(
    () => new Set(useNotificationsStore.getState().notifications.map((item) => item.id))
  )

  const notification = notifications.find(
    (item) => !initialNotificationIds.has(item.id) && !item.isRead && item.actions && item.actions.length > 0
  )

  const handleAction = useCallback(
    (notificationId: string, actionId: string) => {
      markAsRead(notificationId)

      if (actionId === 'decline') {
        dismissNotification(notificationId)
      }
    },
    [dismissNotification, markAsRead]
  )

  if (!notification) {
    return null
  }

  return (
    <div className={styles.toast}>
      <NotificationCard notification={notification} onAction={handleAction} />
    </div>
  )
}
